import { useFormik } from 'formik';
import { initialValues } from './formData';
import { Param } from '../../../../../shared/types/param';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { asyncGetParams } from '../../../../../services/param.service';

export const usePqrReceivedThroughFilters = (
    onFilter?: (data: Param) => void
) => {
    const [types, setTypes] = useState<ISelect[]>([]);
    const onSubmit = (data: Param) => {
        if (onFilter) onFilter(data || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_TYPE).then((params) =>
            setTypes(params.map(({ name }) => ({ id: name, name })))
        );
    }, []);

    return {
        formik,
        types,
    };
};
